import React, { useEffect, useState, useRef } from 'react';
import './Map.css';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import axios from 'axios'; // Import axios
import {useNavigate} from 'react-router-dom';
import Loading from './Loading';
import Swal from 'sweetalert2';
import { NavigationControl, ScaleControl } from 'maplibre-gl';

function ButtonContainer({ map}) {
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilterLayer, setSelectedFilterLayer] = useState('');
  const [selectedListItemIndex, setSelectedListItemIndex] = useState(null);
  const [activeButton, setActiveButton] = useState('');
  

 


  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude, accuracy } = position.coords;
          map.flyTo({
            center: [longitude, latitude],
            zoom: 25,
          });
  
          // Create a GeoJSON point feature for the current location
          const pointFeature = {
            type: 'Feature',
            geometry: {
              type: 'Point',
              coordinates: [longitude, latitude],
            },
            properties: {
              title: 'Current Location',
              description: `Accuracy: ${accuracy} meters`,
            },
          };
  
          // Add the point feature source
          map.addSource('current-location', {
            type: 'geojson',
            data: pointFeature,
          });
  
          // Add a circle layer to represent the accuracy
          map.addLayer({
            id: 'current-location-circle',
            type: 'circle',
            source: 'current-location',
            paint: {
              'circle-radius': accuracy,
              'circle-color': 'black',
              'circle-opacity': 0.3,
              'circle-stroke-color': 'black',
              'circle-stroke-width': 1,
            },
          });
  
       
        },
        (error) => {
          console.error('Error getting current location:', error.message);
        },
        // Optional: Add options for better accuracy
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      console.error('Geolocation is not supported by your browser.');
    }
  };
  const resetActiveButtonState = () => {
    setActiveButton('');
  };
  
  return (
    <div className="button-container">
         <button onClick={getCurrentLocation}>
        <i className="fas fa-location-arrow" title="Current location" ></i>
      </button>
     
    

    

     

   
    </div>
  );
}
function Map() {
  const [map, setMap] = useState(null);
  const [baselayer, setBaselayer] = useState(
    'https://api.maptiler.com/maps/streets-v2/style.json?key=Otbh9YhFMbwux7HyoffB'
  );
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectCountry, setSelectCountry] = useState('');
  const [countries, setCountries] = useState([]);
    // Function to check if any field is blank
    const countryFieldBlank = () => {
      return  selectCountry === '';
    };
    
    const locationFieldBlank = () => {
      return selectedLocation=== null;
    };
  
  const sourceRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('https://quickstart-mmapfxurda-ew.a.run.app/api/CountryList')
      .then((response) => response.json())
      .then((data) => setCountries(data))
      .catch((error) => console.error('Error fetching countries:', error));
  }, []);

  useEffect(() => {
    if (!map) {
      const newMap = new maplibregl.Map({
        container: 'map',
        style: baselayer,
        center: [29.970462, -19.080641],
        zoom: 1,
      });

      setMap(newMap);
    }

    if (map) {
      map.addControl(new ScaleControl(), 'bottom-left');
      map.addControl(new NavigationControl(), 'top-right');
    }

    return () => map?.remove();
  }, [map, baselayer]);

  useEffect(() => {
    let marker = null;

    if (map) {
      map.on('click', (e) => {
        const { lng, lat } = e.lngLat;

        if (marker) {
          marker.remove();
        }

        marker = new maplibregl.Marker().setLngLat([lng, lat]).addTo(map);

        setSelectedLocation({ lng, lat });
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
      });
    }

    return () => {
      if (marker) {
        marker.remove();
      }
    };
  }, [map]);

  const handleQueryButtonClick = async () => {
    if (countryFieldBlank()) {
      // Display sweet popup for missing country
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please select the country',
      });
    } else if (locationFieldBlank()) {
      // Display sweet popup for missing location
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please mark on the map to fill latitude and longitude values',
      });
    } else {
      const { lat, lng } = selectedLocation;
  
      // Set loading to true when making the API call
      setLoading(true);
  
      try {
        const response = await axios.get(
          `https://quickstart-mmapfxurda-ew.a.run.app/api/retrieve_data_and_check_point/?point_x=${lng}&point_y=${lat}&selectCountry=${selectCountry}`
        );
  
        // Handle the response as needed (e.g., log or update state)
        console.log('API response:', response);
        const farmname = response.data.farm_region_result.properties.name;
        console.log(farmname)
        const soiltype = response.data.soil_type_result.properties.name;
        console.log(soiltype)
        // Use the useNavigate hook from react-router-dom to navigate to the '/Calendar' route
          // Navigate to '/Calendar' route
          navigate('/Calendar', { state: { farmname, soiltype, selectCountry } });
        
        
      } catch (error) {
         // Display sweet popup for missing location
         Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: `Kindly mark the location within ${selectCountry}`,
        });
        console.error('Error making API call:', error);
      } finally {
        // Set loading back to false after the API call is complete
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const handleCountrySelect = () => {
      const selectedCountryData = countries.find(
        (country) => country.name === selectCountry
      );

      if (selectedCountryData && map) {
        const { center_longitude, center_latitude } = selectedCountryData;

        map.flyTo({
          center: [center_longitude, center_latitude],
          zoom: 6, // Replace with your desired zoom level
        });
      }
    };

    // Call the function when selectedCountry changes
    handleCountrySelect();
  }, [selectCountry, countries, map]); // Depend on selectedCountry, countries, and map


  return (
    <div className="map-container">
      <div id="map"></div>
      {map && <ButtonContainer map={map} />}
      {loading && <Loading />}
      <form className="overlay-form">
        <i
          className="fas fa-info-circle icon"
          title="Please select the country you want to query the farm data and mark on the map within that country location"
        ></i>

        <div className="row">
          <select
            id="country"
            value={selectCountry}
            onChange={(e) => {setSelectCountry(e.target.value);}}
        

          >
            <option value="">Select a country</option>
            {countries.map((country) => (
              <option key={country.id} value={country.name}>
                {country.name}
              </option>
            ))}
          </select>
        </div>

        <div className="row">
          <input
            title="Kindly mark a location on the map to fill this field."
            type="text"
            id="latitude"
            placeholder="latitude"
            value={latitude}
            onChange={(e) => setLatitude(e.target.value)}
            disabled
          />
        </div>

        <div className="row">
          <input
            title="Kindly mark a location on the map to fill this field."
            type="text"
            id="longitude"
            placeholder="longitude"
            value={longitude}
            onChange={(e) => setLongitude(e.target.value)}
            disabled
          />
        </div>

        <button
          title="Upon clicking this button, a data query will be initiated from the database based on the selected coordinates."
          type="button"
          onClick={handleQueryButtonClick}
        >
          <i className="fas fa-search"></i>
        </button>
      </form>
    </div>
  );
}

export default Map;